"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var uri_1 = require("@cian/chats-api/lib/browser/websocket/uri");
var http_client_1 = require("@cian/http-client");
var http_client_2 = require("../http_client");
function getChatsBaseAPI() {
    // tslint:disable-next-line:no-any
    var chatsBaseHttpApi = window.__header_chats_base_http_api__;
    var chatsHttpConfig = chatsBaseHttpApi && {
        baseUri: http_client_1.parseURI(chatsBaseHttpApi),
        client: http_client_2.httpClient,
    };
    // tslint:disable-next-line:no-any
    var chatsBaseWsApi = window.__header_chats_base_ws_api__;
    var chatsBaseWSUri = chatsBaseWsApi && uri_1.parseURI(chatsBaseWsApi);
    return {
        chatsHttpConfig: chatsHttpConfig,
        chatsBaseWSUri: chatsBaseWSUri,
    };
}
exports.getChatsBaseAPI = getChatsBaseAPI;



//////////////////
// WEBPACK FOOTER
// ./src/browser/utils/chats_network_helper.ts
// module id = 292
// module chunks = 2